import React from 'react';
import get from 'lodash/get';
import cs from 'classnames';
import {connect} from 'react-redux';
import includes from 'lodash/includes';

import {DEFAULTS} from '../../../misc/search';
import {searchResultsToggle, closePremiumToolTip} from '~/modules/loads/actions';
import LoadCard from './LoadCard';
import PremiumRowReplacer from './PremiumRowReplacer';
import Button from '~/components/common/Button';
import Spinner from '~/components/common/Spinner';
import SortSelect from './SortSelect';
import {RowsHeader, LoadRow} from './LoadRow';
import mapDispatch from '~/misc/mapDispatch';
import UserJobBanner from '~/components/common/UserJobBanner';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import {alterHideConfirm} from '~/modules/hideConfirm/actions';
import {Link} from 'react-router';
import {loadsClickTimes} from '~/modules/premiumSwitch/actions';
import {track} from '~/misc/metrics';
import {viewLoad} from '~/modules/myLoads/actions';
import store from '~/store';

import css from './results.css';
import sharedCSS from '../../shared.css';

const isSpider = () => {
  if (navigator.userAgent.indexOf('Googlebot') > -1){
    return true;
  }
  return false;
}

let randowBooleanNum;
let upgradePopNum;

const ReconfirmPopup = ({id, company, alterHideConfirm, hideBroker}) => (
  <div className={cs(css.reconfirmPopup)}>
    <div className={cs(css.popupContent)}>
      <div
        className={cs(css.shutDown)}
        onClick={() => {alterHideConfirm({hideConfirm: false, id: null, company: ''});}}
      >
        <span className={cs(css.downLeft)} />
        <span className={cs(css.downRight)} />
      </div>
      <p className={cs(css.sure)}>Are you sure?</p>
      <p className={cs(css.hidingCompany)}>
        Blocking this company will block all their loads from your search results.
        To manage your favorites or blocks, go to Settings {'>'}
        <Link to='/my-company'>My Brokers/Shippers</Link>.
      </p>
      <div className={cs(css.confirm)}>
        <button
          className={cs(css.attrCancel)}
          onClick={() => {alterHideConfirm({hideConfirm: false, id: null, company: ''});}}
        >Cancel</button>
        <button
          className={cs(css.attrYes)}
          onClick={() => {alterHideConfirm({hideConfirm: false, id: null, company: ''}); hideBroker({id, company});}}
        >Yes</button>
      </div>
    </div>
  </div>
);

const InteractiveRow = connect((
  {
    loads: {viewed, active},
    user: {isLoggedIn},
    loadsSearch,
    account: {accountLevel, free, premium},
    window: {globalParams}
  },
  {i, hideClick, saveClick}
) => ({
  viewed: viewed[i.id],
  active: i.identity && active[i.identity.mediumkey], // && isLoggedIn
  deleted: Boolean(i.deleted || i.expired || (loadsSearch.deletedIndex && loadsSearch.deletedIndex[i.id])),
  // userIsLoggedIn: isLoggedIn,
  accountLevel: accountLevel,
  free: free,
  isLink: globalParams['anon'] === 'true' && !isLoggedIn,
  hideClick: hideClick,
  saveClick: saveClick,
  isMember: parseInt(accountLevel) >= parseInt(premium),
}), mapDispatch({
  select: (props, e) => {
    if (!props.isLink) {
      props.wrapClick(e);
    }
    // not show loadcard
    const isViewed = includes(e.currentTarget.classList.toString(), 'rowViewed');
    if (
      !isSpider() && (
      randowBooleanNum
      || (!isViewed && upgradePopNum)
      || (props.loginPopSwitch && props.showUpgradePop && !isViewed)
      || props.showEmailPop
      || (!isViewed && props.showUpgradePop))) {
      return searchResultsToggle(props.i.identity, true);
    }
    if (!isViewed) {
      store.dispatch(viewLoad(props.i.id));
    }
    return searchResultsToggle(props.i.identity);
  },
  hideBroker: (props, data) => props.hideBroker(data),
  collectionTheCompany: (props, data) => props.collectionTheCompany(data),
  noCollectionCompany: (props, data) => props.noCollectionCompany(data),
  showUpgradeToEst :(props) => {
    const eventName =
      window.location.href.indexOf("searchloads") >= 0
        ? "Est.Price"
        : "Est.Price_inpage";
    track("est_price", {
      count: 1,
    });
    return modalChange("pop", {
      source: eventName,
      type: "pop_upgrade_to_premium_est",
    });
  },
  showUltimateUpgradeToEst :(props,clickType) => {
    console.log('clickType',clickType)
    let eventName = ''
    
    switch (clickType) {
      case 'ratio':
        eventName = window.location.href.indexOf("searchloads") >= 0
        ? "load_capacity_ratio"
        : "load_capacity_ratio_inpage";
        break;
      case 'indicator':
        eventName = window.location.href.indexOf("searchloads") >= 0
        ? "load_capacity_indicator"
        : "load_capacity_indicator_inpage";
        break;
      default:
        break;
    }
      
    track(eventName, {
      count: 1,
    });
    return modalChange("pop", {
      source: eventName,
      type: "pop_upgrade_to_new_professional",
    });
  },
}))(({i, index, query, select, isFresh, isSimilar, isMain, active, viewed,
  position, deleted, checkbox, info, checkClick, hidePremiumRow, allowBanner,
  showEmailPop, loginPopSwitch, accountLevel, hideBroker, showUpgradePop,isMember , 
  collectionTheCompany, noCollectionCompany, saveClick, hideClick, isLink, myloadsType, deletedByBroker, showUpgradeToEst,showUltimateUpgradeToEst
}) => {
  const isPremium = i.featured;
  // const isLoggedIn = userIsLoggedIn;

  if (isPremium && hidePremiumRow) {
    return <PremiumRowReplacer/>;
  }
  return (
    <div
      className={cs(css.loadWrap, {
        [css.loadWrapSelected]: active && !loginPopSwitch && !showEmailPop,
        [`qa-newLoad qa-newLoad-${index}`]: isFresh,
        [`qa-load qa-load-${index}`]: !isFresh,
      })}
    >
      <LoadRow
        dataQa='search-results-slim'
        query={query}
        load={i}
        position={position}
        onClick={select}
        active={active && ((!loginPopSwitch && !showUpgradePop && !showEmailPop) || viewed)}
        viewed={viewed}
        isSimilar={isSimilar}
        isMain={isMain}
        checkbox={checkbox}
        checkClick={checkClick}
        isFresh={isFresh}
        unlockFn={showUpgradeToEst}
        isMember={isMember}
      />
      {active && !isLink && ((!loginPopSwitch && !showUpgradePop && !showEmailPop) || viewed) && (
        <div className={css.detailsWrap}>
          <LoadCard
            item={i}
            query={query}
            accountLevel={accountLevel}
            isPremium={isPremium}
            deleted={deleted}
            showLink={true}
            hideBroker={hideBroker}
            collectionTheCompany={collectionTheCompany}
            noCollectionCompany={noCollectionCompany}
            saveClick={saveClick}
            deletedByBroker={deletedByBroker}
            hideClick={hideClick}
            myloadsType={myloadsType}
            unlockFn={showUpgradeToEst}
            unlockUltimateFn={showUltimateUpgradeToEst}
            isMember={isMember}
          />
        </div>
      )
      }
      {/* hide information collection area */}
      {/* {allowBanner && position === 4 && (
        <div>
          <UserJobBanner/>
        </div>
      )} */}
    </div>
  );
});

class results extends React.Component {
  constructor(props) {
    super(props);
    this.showMore = this.showMore.bind(this);
    this.select = this.select.bind(this);
    this.saveMainStart = this.saveMainStart.bind(this);
    this.randomShowPop = this.randomShowPop.bind(this);
    this.judgeMember = this.judgeMember.bind(this);
    this.state = {
      loginPopSwitch: Boolean(props.emailPopSwitch && !props.isLoggedIn),
      emailPopSwitch: false,
      upgradePop: props.memberSwitchData.switch
        && (props.memberSwitchData.times <= props.localLoadsClickTimes)
        && !this.judgeMember(),
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      loginPopSwitch: Boolean(nextProps.emailPopSwitch && !nextProps.isLoggedIn),
      upgradePop: nextProps.memberSwitchData.switch
      && (nextProps.memberSwitchData.times <= nextProps.localLoadsClickTimes)
      && !this.judgeMember(),
    });
    if (!this.props.isMain) {
      return;
    }
    const oldProps = this.props;

    const oldValue = get(oldProps, 'addedItemsFlat.length', 0);
    const newValue = get(nextProps, 'addedItemsFlat.length', 0);

    this.willDamage = oldValue !== newValue;
    this.currentScrollPosition = window.document.body.scrollTop;
  }

  componentDidUpdate() {
    if (!this.props.isMain || !this.mainStart) {
      return;
    }

    const prevPos = this.tablePos;

    // remember table position after any updates for some possible damage in future
    // (to have `prevPos` in that situation)
    this.tablePos = this.mainStart.getBoundingClientRect().top;

    if (!this.willDamage) {
      return;
    }

    const bottomLimit = this.currentScrollPosition + window.innerHeight * 2 / 3;
    const hasUserInterest = prevPos < bottomLimit;

    if (hasUserInterest) {
      window.document.body.scrollTop += (this.tablePos - prevPos);
    }

    this.willDamage = false;
  }

  render() {
    /* eslint-disable */
    return (
      <div className={cs(sharedCSS.wideStretchable, sharedCSS.box, css.wrap, sharedCSS.unpadded)}>
        {this.renderResults()}
        {this.renderPaging()}
      </div>
    );
  }

  renderNotFound() {
    return (
      <div className={cs(css.wrapNotFound, 'qa-no-results')}>
        <div>
          Oops! Your search did not exactly match any loads.
        </div>
        <div>Please browse similar matches below or edit your search and try again</div>
      </div>
    );
  }

  renderResults() {
    const { hasItems, info } = this.props;
    return (
      <div>
        {hasItems && info}
        <div className={css.list}>
          <div className={cs(css.head,
            {[css.padding]: this.props.sorting, [css.loadCenter]: !this.props.sorting})}
          >
            {(this.props.sorting === true || !this.props.info) ? this.props.header : null}
            {this.props.sorting === false ? null : (
              <div className={css.sortSelectWrapper}>
                <SortSelect
                  loadsSort={this.props.loadsSort}
                  dispatch={this.props.dispatch}
                  query={this.props.query}
                  fetching={this.props.status === 'sorting'}
                  isSimilar={this.props.isSimilar}
                />
              </div>
            )}
          </div>
          {this.renderTable(get(this.props, 'results.shipments'), this.props.addedItemsFlat)}
        </div>
      </div>
    );
  }

  renderTable(list, addedItemsFlat) {
    if ((!list || !list.length) && (!addedItemsFlat || !addedItemsFlat.length)) {
      return this.renderNotFound();
    }
    const {query, hideConfirm, isSimilar, isMain, hidePremiumRow, allowBanner, hideBroker,
      collectionTheCompany, noCollectionCompany, saveClick, hideClick,
      alterHideConfirm, viewed, myloadsType, headerSticky} = this.props;
    const startNum = addedItemsFlat ? addedItemsFlat.length : 0;
    upgradePopNum = this.state.upgradePop;

    return (
      <div className={css.loadsGroup}>
        <div className={css.listContainer}>
          <div className={cs(css.headerWrap, {[css.headerSticky]: headerSticky})}>
            <RowsHeader
              checkbox={this.props.checkbox}
              isSimilar={isSimilar}
              checkedAll={this.props.checkedAll}
              checkedAllClick={this.props.checkedAllClick}
            />
          </div>

          {addedItemsFlat && addedItemsFlat.map((item, num) => (
            <InteractiveRow
              key={`r${item.id}${"-"+(myloadsType || "Loads")}`}
              i={item}
              wrapClick={(e) => this.select(e, item)}
              index={addedItemsFlat.length - 1 - num}
              position={num}
              query={query}
              isSimilar={isSimilar}
              isMain={isMain}
              isLink={this.props.isLink}
              checkbox={this.props.checkbox}
              info={this.props.info}
              checkClick={this.props.checkClick}
              isFresh={true}
              hidePremiumRow={hidePremiumRow}
              allowBanner={allowBanner}
              hideBroker={hideBroker}
              collectionTheCompany={collectionTheCompany}
              noCollectionCompany={noCollectionCompany}
              saveClick={saveClick}
              hideClick={hideClick}
              isViewed={viewed[item.id]}
              deletedByBroker={item.deletedByBroker}
              loginPopSwitch = {this.state.loginPopSwitch}
              showEmailPop={this.state.emailPopSwitch}
              showUpgradePop = {this.state.upgradePop}
              myloadsType={myloadsType}
            />
          ))}

          {Boolean(this.props.isMain && list && list.length) && (
            <div ref={this.saveMainStart} />
          )}

          {list.map((item, num) => (
            <InteractiveRow
              key={`r${item.id}${"-"+(myloadsType || "Loads")}`}
              i={item}
              wrapClick={(e) => this.select(e, item)}
              index={num}
              position={num + startNum}
              query={query}
              isSimilar={isSimilar}
              isMain={isMain}
              isLink={this.props.isLink}
              hidePremiumRow={hidePremiumRow}
              allowBanner={allowBanner}
              checkbox={this.props.checkbox}
              info={this.props.info}
              hideBroker={hideBroker}
              collectionTheCompany={collectionTheCompany}
              noCollectionCompany={noCollectionCompany}
              checkClick={this.props.checkClick}
              saveClick={saveClick}
              hideClick={hideClick}
              isViewed={viewed[item.id]}
              deletedByBroker={item.deletedByBroker}
              loginPopSwitch = {this.state.loginPopSwitch}
              showEmailPop={this.state.emailPopSwitch}
              showUpgradePop = {this.state.upgradePop}
              myloadsType={myloadsType}
            />
          ))}
        </div>
        {hideConfirm
          ? <ReconfirmPopup
            id={this.props.hideId}
            company={this.props.hideCompany}
            alterHideConfirm={alterHideConfirm}
            hideBroker={hideBroker}
          />
          : null
        }
      </div>
    );
  }

  renderPaging() {
    return (
      this.props.status === 'fetchingMore'
        ? <div className={css.pagingButtonWrap}><Spinner qa='more-search-results'/></div>
        : this.renderShowMore()
    );
  }

  renderShowMore() {
    if (!this.props.showMore) {
      return null;
    }
    const shown = get(this.props, 'results.shipments.length');
    // const total = this.props.total;
    const total = this.props.localSum ? this.props.localSum.length : null;
    if (!total) {
      return null;
    }


    if (shown === total || shown >= 200) {
      return null;
    }

    let message = `Show ${DEFAULTS.limit} More`;


    if (shown + DEFAULTS.limit > total) {
      message = `Show Last ${total - shown}`;
    }

    return (<div className={css.pagingButtonWrap}>
      <Button onClick={this.showMore} data-qa='show-more'>{message}</Button>
    </div>);
  }

  judgeMember() {
    const {accountLevel, free, isL2User} = this.props;
    if (parseInt(accountLevel) > parseInt(free)) {
      return true;
    }
    if (isL2User) {
      return true;
    }
    return false;
  }

  saveMainStart(node) {
    this.mainStart = node;
  }

  showMore() {
    this.props.showMore(DEFAULTS.limit);
  }

  randomShowPop(data) {
    const user = this.props.user;

    // profile msg incomplete
    if (
      data.emailPopSwitch &&
      data.emailPopRate === 100 &&
      (
        !user.emailVerified || !user.firstName || !user.lastName || !user.phone ||
        (!user.dot_verified && !user.mc_verified))
    ) {
      return true;
    }

    return false;
  }

  select(e) {
    e.preventDefault();
    e.stopPropagation();
    const isPremium = e.currentTarget.getAttribute('data-premium') === 'true';
    const close = this.props.closePremiumToolTip;
    // const randowBoolean = this.randomShowPop(this.props);
    const active = includes(e.currentTarget.classList.toString(), 'rowSelected');
    const isViewd = includes(e.currentTarget.classList.toString(), 'rowViewed');

    // randowBooleanNum = randowBoolean;
    // this.setState({
    //   emailPopSwitch: randowBoolean,
    // });

    if (isPremium && !this.props.premiumToolTipHidden) {
      document.addEventListener('click', function oneTime() {
        document.removeEventListener('click', oneTime);
        close();
      });
    }

    // 没有登陆，引导用户去登陆。
    // if (!this.props.isLoggedIn && (this.props.emailPopSwitch || this.props.switchData)) {
    //   return this.props.login();
    // }
    // if (!this.props.isLoggedIn && this.state.upgradePop && !isViewd) {
    //   return this.props.login();
    // }

    // 非会员，而且查看的次数抵达上限的时候，弹出弹出层，引导用户购买会员。
    // if (this.state.upgradePop && !isViewd) {
    //   track('free user limit popup', {result: 'upgrade'});
    //   return this.props.showUpgradeToStandard();
    // }
    if (this.state.upgradePop && !isViewd && !isSpider()) {
        //track('free user limit popup', {result: 'upgrade'});
      const {times} = this.props.memberSwitchData;
      return this.props.showUpgradeToPremium(times);
    }
    //
    // // filter loads has open
    // if (randowBoolean && !active) {
    //   return this.props.showDownloadAppAndSendEmail();
    // }

    // 已经登陆而且不是会员，查看次数限制。
    if (!isViewd && !isSpider()) {
      this.props.loadsClickTimes();
    }

    return null;
  }
}

export default connect(({loads, user, dots, hideConfirm, premiumSwitch, account, window}) => ({
  viewed: loads.viewed,
  isLoggedIn: user.isLoggedIn,
  isL2User: user.isL2User,
  isLink: window.globalParams['anon'] === 'true' && !user.isLoggedIn,
  globalParams: window.globalParams,
  emailPopSwitch: dots.mainSwitch.data.email_switch.switch,
  emailPopRate: dots.mainSwitch.data.email_switch.chance,
  hideConfirm: hideConfirm.hideConfirm,
  hideId: hideConfirm.id,
  hideCompany: hideConfirm.company,
  memberSwitchData: premiumSwitch.memberSwitchData,
  localLoadsClickTimes: premiumSwitch.localLoadsClickTimes,
  accountLevel: account.accountLevel,
  free: account.free,
  user,
}), mapDispatch({
  login: () => modalChange(modes.LOGIN, 'loads'),
  dotPop: () => modalChange(modes.DOT_VALIDATE, 'loads'),
  closePremiumToolTip: () => closePremiumToolTip(),
  alterHideConfirm: (props, data) => alterHideConfirm(data),
  showUpgradeToStandard: (props) => modalChange('pop', {
    source: 'load-list',
    type: 'pop_upgrade_to_loads_above_limits',
  }),
  showDownloadAppAndSendEmail: (props) => modalChange('pop', {
    source: 'load-list',
    type: 'pop_download_and_send_verify_email',
  }),
  loadsClickTimes: () => loadsClickTimes(),
  showUpgradeToPremium: (props, data) => modalChange('pop', {
    times: data,
    source: 'load-list',
    type: 'pop_upgrade_to_new_standard',
  }),
}))(results);



// WEBPACK FOOTER //
// ./src/components/search/results/results.js